module.exports = __webpack_public_path__ + "media/dashboard/assets/icons/call/addCard-9861073eb169ee6a21769d3d06cc3e3d.svg";